// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 954) return "subsite-china/954-ae3a2f3fa983519d02e9.js";
	if (chunkId === 532) return "subsite-china/styles-4eaeceb620afdd1ebc91.js";
	if (chunkId === 351) return "subsite-china/commons-9e7472d2284dd181594d.js";
	if (chunkId === 875) return "subsite-china/190f48e1d712abf1b23afe7d98d0424ba15cabee-dc3e5444159f3a1af58b.js";
	if (chunkId === 218) return "subsite-china/component---src-pages-404-tsx-bc046ed22b2abfab8050.js";
	if (chunkId === 278) return "subsite-china/b0c88c5e5b54854a066ab8be45f25781c5307858-10408a6c7992ed1f0adc.js";
	if (chunkId === 904) return "subsite-china/2d1c9d34d7cabdcdf27eb8ffad16bade3b93f9b1-aa8d39c84ad47a2a839d.js";
	if (chunkId === 660) return "subsite-china/component---src-templates-personal-area-calendar-page-index-tsx-f1bc2be339303df2b7dc.js";
	if (chunkId === 456) return "subsite-china/8bd7444894d603c816394f87921cda61ce72b74b-654191e0e95b25799a17.js";
	if (chunkId === 874) return "subsite-china/component---src-templates-personal-area-profile-page-index-tsx-96530892ff506ca9d575.js";
	if (chunkId === 323) return "subsite-china/component---src-templates-qr-index-tsx-69b497fdc9b90e394fe4.js";
	if (chunkId === 77) return "subsite-china/component---src-templates-search-page-index-tsx-fa9b89e17cf1c81a3e39.js";
	if (chunkId === 737) return "subsite-china/fb7d5399-676b68a04b51ec9c104f.js";
	if (chunkId === 863) return "subsite-china/072d4843-f666d5d654158e360dce.js";
	if (chunkId === 208) return "subsite-china/2aacc723-9c71b3be662d5341a288.js";
	if (chunkId === 344) return "subsite-china/bf322c48-3cfb97ea429d92ed63a2.js";
	if (chunkId === 811) return "subsite-china/22e32791-472b765fd8810288059c.js";
	if (chunkId === 312) return "subsite-china/409a021e-a472e56ad96e5dd9db24.js";
	if (chunkId === 125) return "subsite-china/b2d36f25-d1299abc6a08d477a227.js";
	if (chunkId === 255) return "subsite-china/7d0bf13e-bdf71c7a80db8e396ca0.js";
	if (chunkId === 330) return "subsite-china/component---src-templates-standard-page-index-tsx-44e72f09f8a5819bd4b5.js";
	if (chunkId === 731) return "subsite-china/731-24c01cd9aa8f4dae3f56.js";
	if (chunkId === 843) return "subsite-china/843-fab9d1e58ff991ed4ec3.js";
	// return url for filenames based on template
	return undefined;
};